/**
 * Language constants.
 *
 * The languages offered besides English come ONLY from the backend
 * (GET /translation/v1/languages, see services/languageService.js). The last answer is kept in
 * the browser so the next visit can show it immediately; there is no built-in list. If the
 * backend has never answered, the switcher offers English only and says so.
 *
 * A language entry in the app looks like:
 *   { code: 'ar', label: 'العربية', englishName: 'Arabic', dir: 'rtl' }
 *   `code`  is what is sent to the translation API and stored in localStorage
 *   `label` is the language's own name, shown in the switcher (never translated)
 */

/** The language every screen is written in. It is never sent for translation. */
export const SOURCE_LANGUAGE = 'en';
export const DEFAULT_LANGUAGE = 'en';

/** English is the page itself, so the backend does not list it; we always add it first. */
export const SOURCE_LANGUAGE_ENTRY = Object.freeze({
    code: 'en',
    label: 'English',
    englishName: 'English',
    dir: 'ltr',
});

/**
 * Small interface texts shown by the switcher itself, written directly in each language
 * (the switcher is excluded from translation, so these are not machine-translated).
 * A language without an entry here uses the English texts.
 */
export const SWITCHER_MESSAGES = Object.freeze({
    en: {
        selectLanguage: 'Select language',
        translating: 'Translating…',
        unavailable: 'Translation is unavailable right now',
        loadingLanguages: 'Loading languages…',
        languagesUnavailable: 'Languages could not be loaded',
        retry: 'Retry',
        notice: '',
    },
    ar: {
        selectLanguage: 'اختر اللغة',
        translating: 'جارٍ الترجمة…',
        unavailable: 'الترجمة غير متاحة حاليًا',
        loadingLanguages: 'جارٍ تحميل اللغات…',
        languagesUnavailable: 'تعذّر تحميل اللغات',
        retry: 'إعادة المحاولة',
        notice: 'تُترجم هذه الصفحة تلقائيًا بالذكاء الاصطناعي وقد تحتوي على أخطاء.',
    },
    es: {
        selectLanguage: 'Seleccionar idioma',
        translating: 'Traduciendo…',
        unavailable: 'La traducción no está disponible ahora',
        loadingLanguages: 'Cargando idiomas…',
        languagesUnavailable: 'No se pudieron cargar los idiomas',
        retry: 'Reintentar',
        notice: 'Esta página se traduce automáticamente con IA y puede contener errores.',
    },
    pt: {
        selectLanguage: 'Selecionar idioma',
        translating: 'Traduzindo…',
        unavailable: 'A tradução não está disponível agora',
        loadingLanguages: 'Carregando idiomas…',
        languagesUnavailable: 'Não foi possível carregar os idiomas',
        retry: 'Tentar novamente',
        notice: 'Esta página é traduzida automaticamente por IA e pode conter erros.',
    },
});
